import React from 'react';
import { useLocation } from 'react-router-dom';
import { BellIcon, DownloadIcon, SearchIcon, ChevronDownIcon, MenuIcon, SunIcon, MoonIcon } from 'lucide-react';
import { useApp } from '../../context/AppContext';
const titles: Record<string, string> = {
  '/': 'Reporting Overview',
  '/reports': 'Report Library',
  '/builder': 'Report Builder',
  '/templates': 'My Templates'
};
export function TopBar() {
  const {
    exports,
    setQueuePanelOpen,
    queuePanelOpen,
    theme,
    toggleTheme,
    setMobileNavOpen
  } = useApp();
  const location = useLocation();
  const activeJobs = exports.filter(e => e.status === 'queued' || e.status === 'processing').length;
  const title = titles[location.pathname] ?? (location.pathname.startsWith('/reports/') ? 'Report Viewer' : 'Reporting');
  return <header className="flex h-16 shrink-0 items-center justify-between px-4 sm:px-6" data-id="element-181">
      <div className="flex items-center gap-3" data-id="element-182">
        <button type="button" onClick={() => setMobileNavOpen(true)} aria-label="Open navigation menu" className="card-float flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy-600 transition-colors hover:text-navy-900 lg:hidden" data-id="element-183">
          <MenuIcon className="h-4 w-4" data-id="element-184" />
        </button>
        <h1 className="text-[15px] font-semibold tracking-tight text-navy-900" data-id="element-185">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-186">
        <div className="relative hidden md:block" data-id="element-187">
          <SearchIcon className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-navy-400" data-id="element-188" />
          <input type="search" placeholder="Search reports…" aria-label="Search reports" className="card-float h-9 w-56 rounded-full border border-transparent bg-white pl-10 pr-4 text-sm text-navy-900 placeholder:text-navy-400 focus:border-navy-200 focus:outline-none focus:ring-2 focus:ring-navy-900/10" data-id="element-189" />
        </div>
        <button type="button" onClick={toggleTheme} aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} className="card-float flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy-600 transition-colors hover:text-navy-900" data-id="element-190">
          {theme === 'dark' ? <SunIcon className="h-4 w-4" data-id="element-191" /> : <MoonIcon className="h-4 w-4" data-id="element-192" />}
        </button>
        <button type="button" onClick={() => setQueuePanelOpen(!queuePanelOpen)} aria-label={`Export queue, ${activeJobs} active jobs`} className="card-float relative flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy-600 transition-colors hover:text-navy-900" data-id="element-193">
          <DownloadIcon className="h-4 w-4" data-id="element-194" />
          {activeJobs > 0 && <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-gold-500 px-1 text-[10px] font-bold text-white" data-id="element-195">
              {activeJobs}
            </span>}
        </button>
        <button type="button" aria-label="Notifications" className="card-float relative flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy-600 transition-colors hover:text-navy-900" data-id="element-196">
          <BellIcon className="h-4 w-4" data-id="element-197" />
          <span className="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-rose-500" data-id="element-198" />
        </button>
        <button type="button" className="card-float flex items-center gap-2 rounded-full bg-white py-1 pl-1 pr-3 transition-shadow hover:card-float-lg" data-id="element-199">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-navy-900 text-xs font-semibold text-white" data-id="element-200">
            RM
          </span>
          <span className="hidden text-sm font-medium text-navy-800 sm:block" data-id="element-201">
            Robert M.
          </span>
          <ChevronDownIcon className="hidden h-3.5 w-3.5 text-navy-400 sm:block" data-id="element-202" />
        </button>
      </div>
    </header>;
}